var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCilPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M420 128.1V16H92V128.1C71.5093 129.15 52.2028 138.023 38.062 152.89C23.9212 167.756 16.0243 187.482 16 208V400H84V368H48V208C48.0143 195.274 53.076 183.073 62.0747 174.075C71.0733 165.076 83.274 160.014 96 160H416C428.726 160.014 440.927 165.076 449.925 174.075C458.924 183.073 463.986 195.274 464 208V368H420V400H496V208C495.976 187.482 488.079 167.756 473.938 152.89C459.797 138.023 440.491 129.15 420 128.1ZM388 128H124V48H388V128Z",
    className: "svgFill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M396 200H428V232H396V200ZM116 264H76V296H116V496H388V296H428V264H116ZM356 464H148V296H356V464Z",
    className: "svgFill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCilPrint);
export default __webpack_public_path__ + "static/media/cil_print.45f75cd4.svg";
export { ForwardRef as ReactComponent };